/**
 * 
 */
class WMUBlockSwitchLang {

    switchLangSelector = '.wmu-block.block-switch-lang select';

    /**
	 * 
	 */
	constructor()
	{
        this.onDOMContentLoaded = this.onDOMContentLoaded.bind( this );
        document.addEventListener( 'DOMContentLoaded', this.onDOMContentLoaded );
    }

    init()
    {
        const elements = document.querySelectorAll( this.switchLangSelector );

		elements.forEach( ( element ) =>
		{
            element.addEventListener( 'change', (event) => {
                if (document.location.href != element.value) {
                    document.location.href = element.value ;
                }
            } );
        } );
    }

    onDOMContentLoaded()
    {
        this.init();
    }
}

export default WMUBlockSwitchLang;